// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

import apiHandle from '../../../../../configs/apiConfig'


export const managePayTypeCreate = createAsyncThunk('managePayType/application/create', async (params) => {
  const response = await apiHandle('POST', 'application/paybalance', params)
  return response
})

export const managePayTypeRefund = createAsyncThunk('managePayType/application/refund', async (params) => {
  const response = await apiHandle('POST', 'application/refund', params)
  return response
})

export const managePayTypeDelete = createAsyncThunk('managePayType/application/delete', async (params) => {
  const response = await apiHandle('POST', 'application/delete', params)
  return response
})


export const managePayTypePDFCreate = createAsyncThunk('managePayType/application/pdf/create', async (params) => {
  const response = await apiHandle('POST', 'application/pdf', params)
  return response
})

export const managePayTypeReaderCard = createAsyncThunk('managePayType/managePayTypeReaderCard', async () => {
  const response = await apiHandle('GET', 'mockreadercard')
  return response
})

export const getDataTable = createAsyncThunk('managePayType/getDataTable', async (params) => {
  const response = await apiHandle('GET', 'application/gettable', params)
  return response
})

export const managePayTypeDataDetail = createAsyncThunk('managePayType/managePayTypeDataDetail', async (params) => {
  const response = await apiHandle('GET', 'application/get', params)
  return response
})

export const managePayTypeGetCourse = createAsyncThunk('managePayType/managePayTypeGetCourse', async (params) => {
  const response = await apiHandle('GET', 'application/getformanagePayType', params)
  return response
})

export const getAllData = createAsyncThunk('managePayType/getAllData', async () => {
  const response = await axios.get('/api/users/list/all-data')
  return response.data
})

export const getData = createAsyncThunk('managePayType/getData', async params => {
  const response = await axios.get('/api/users/list/data', params)
  return {
    params,
    data: response.data.users,
    totalPages: response.data.total
  }
})

export const getUser = createAsyncThunk('managePayType/getUser', async id => {
  const response = await axios.get('/api/users/user', { id })
  return response.data.user
})

export const addUser = createAsyncThunk('managePayType/addUser', async (user, { dispatch, getState }) => {
  await axios.post('/apps/users/add-user', user)
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return user
})

export const deleteUser = createAsyncThunk('managePayType/deleteUser', async (id, { dispatch, getState }) => {
  await axios.delete('/apps/users/delete', { id })
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return id
})

const defaultCoruseCost = {
  course_id: '',
  course_name: null,
  promotion_code: null,
  exam_date: null,
  cost: null,
  discount: null,
  paid: null,
  pay_type: null
}

const defaultOtherCost = {
  other_fee_id: null,
  other_fee_name: null,
  promotion_code: null,
  exam_date: null,
  cost: null,
  discount: null,
  paid: null,
  pay_type: null
}

const defaultPayments = {
  payment_id: null,
  payment_code: null,
  pay_type: null,
  paid: null,
  createdAt: null
}


const defaultReisterDetail = {
  is_foreigner: false,
  prefix: '',
  name: '',
  idcard: '',
  birthday: null,
  address: null,
  moo: '',
  soi: '',
  street: '',
  subdistrict: '',
  district: '',
  province: '',
  phone_1: '',
  phone_2: '',
  age: '',
  course: [defaultCoruseCost],
  other_fee: [defaultOtherCost],
  payments: [defaultPayments],
  paid: '',
  discount: '',
  net: '',
  balance: '',
  total: '',
  // pay_type: 'เงินสด',
  status: null,
  application_code: null,
  course_id: '',
  createStatus: false,
  application_id: null,
  pdf: []
}


export const managePayTypeSlice = createSlice({
  name: 'managePayType',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null,
    searchCriteria: {
      branch: { label: 'ทั้งหมด', value: 'ทั้งหมด' },
      status: { label: 'ค้างชำระ', value: 'ค้างชำระ' },
      type: { label: 'ทั้งหมด', value: 'ทั้งหมด' },
      text: ''
    },
    managePayTypeData: {
      data: [],
      filter: {
        branch: [],
        status: [],
        type: []
      },
      meta: {},
      isLoading: false
    },
    managePayTypeDetail: {
      isEdit: false,
      dropdown: {
        course: [],
        other_fee: []
      },
      userData: defaultReisterDetail
    },
    alert: {
      active: false,
      message: ''
    },
    refundAndDelete: {
      application_id: null,
      note: null,
      value: null,
      err: false
    }
  },
  reducers: {
    searchCriteria: (state, action) => {
      if (action.type === 'managePayType/searchCriteria') {
        state.searchCriteria[action.payload.target] = action.payload.value
      }
    },
    managePayTypeNew: (state, action) => {
      if (action.type === 'managePayType/managePayTypeNew') {
        state.managePayTypeDetail.isEdit = false
        state.managePayTypeDetail.userData = defaultReisterDetail
      }
    },
    managePayTypeAddHandle: (state, action) => {
      if (action.type === 'managePayType/managePayTypeAddHandle') {
        if (action.payload.target === 'course') {
          state.managePayTypeDetail.userData.course.push(defaultCoruseCost)
        }
        if (action.payload.target === 'other') {
          state.managePayTypeDetail.userData.other_fee.push(defaultOtherCost)
        }

      }
    },
    managePayTypeDeleteHandle: (state, action) => {
      if (action.type === 'managePayType/managePayTypeDeleteHandle') {
        if (action.payload.target === 'course') {
          state.managePayTypeDetail.userData.course.splice(action.payload.index, 1)
        }
        if (action.payload.target === 'other') {
          state.managePayTypeDetail.userData.other_fee.splice(action.payload.index, 1)
        }

      }

    },
    managePayTypeDropdownHandle: (state, action) => {
      if (action.type === 'managePayType/managePayTypeDropdownHandle') {
        console.log(action.payload.target)
        if (action.payload.target === 'course' && state.managePayTypeDetail.isEdit === false) {
          state.managePayTypeDetail.userData.course[action.payload.index].course_id = action.payload.value.course_id
          state.managePayTypeDetail.userData.course[action.payload.index].course_name = action.payload.value.name
          state.managePayTypeDetail.userData.course[action.payload.index].cost = action.payload.value.price
        }
        if (action.payload.target === 'examDate') {
          state.managePayTypeDetail.userData.course[action.payload.index].exam_date = action.payload.value
        }
        if (action.payload.target === 'other' && state.managePayTypeDetail.isEdit === false) {
          state.managePayTypeDetail.userData.other_fee[action.payload.index].other_fee_id = action.payload.value.other_fee_id
          state.managePayTypeDetail.userData.other_fee[action.payload.index].other_fee_name = action.payload.value.name
          state.managePayTypeDetail.userData.other_fee[action.payload.index].cost = action.payload.value.price
        }
        if (action.payload.target === 'pay_type') {
          state.managePayTypeDetail.userData[action.payload.mode][action.payload.index].pay_type = action.payload.value
        }
      }
    },
    managePayTypeOnChangeHandle: (state, action) => {
      if (action.type === 'managePayType/managePayTypeOnChangeHandle') {
        if (action.payload.target === 'paid') {
          state.managePayTypeDetail.userData[action.payload.mode][action.payload.index][action.payload.target] = action.payload.value
        } else {
          state.managePayTypeDetail.userData[action.payload.target] = action.payload.value
        }

      }
    },
    managePayTypeLoading: (state, action) => {
      if (action.type === 'managePayType/managePayTypeLoading') {
        state.managePayTypeData.isLoading = true
      }
    },
    managePayTypeAlert: (state, action) => {
      if (action.type === 'managePayType/managePayTypeAlert') {
        state.alert.active = false
        state.alert.message = ''
        state.alert.err = false
      }
    },
    managePayTypeRefundDelete: (state, action) => {
      if (action.type === 'managePayType/managePayTypeRefundDelete') {
        if (action.payload.target === null) {
          state.refundAndDelete.application_id = null
          state.refundAndDelete.note = null
          state.refundAndDelete.value = null
        } else {
          state.refundAndDelete[action.payload.target] = action.payload.value
        }

      }
    }

  },
  extraReducers: builder => {
    builder
      .addCase(managePayTypeCreate.fulfilled, (state, action) => {
        if (action.type === 'managePayType/application/create/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
          } else {
            console.log(action)
            state.alert.active = true
            state.alert.message = action.payload.data.pdf
            // state.managePayTypeDetail.userData.createStatus = true
            // state.managePayTypeDetail.userData.pdf = action.payload.data
          }
        }
      })
      .addCase(managePayTypeRefund.fulfilled, (state, action) => {
        if (action.type === 'managePayType/application/refund/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
            state.refundAndDelete.application_id = null
            state.refundAndDelete.note = null
            state.refundAndDelete.value = null
            state.alert.active = true
            state.alert.err = true
            state.alert.message = action.payload.message
          } else {
            state.refundAndDelete.application_id = null
            state.refundAndDelete.note = null
            state.refundAndDelete.value = null
            state.alert.active = true
            state.alert.message = action.payload.message
          }
        }
      })
      .addCase(managePayTypeDelete.fulfilled, (state, action) => {
        if (action.type === 'managePayType/application/delete/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
          } else {
            state.refundAndDelete.application_id = null
            state.refundAndDelete.note = null
            state.refundAndDelete.value = null
            state.alert.active = true
            state.alert.message = action.payload.message
          }
        }
      })
      .addCase(getDataTable.fulfilled, (state, action) => {
        if (action.type === 'managePayType/getDataTable/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
          } else {
            state.managePayTypeData = action.payload
            state.managePayTypeData.isLoading = false
          }
        }
      })
      .addCase(managePayTypeDataDetail.fulfilled, (state, action) => {
        if (action.type === 'managePayType/managePayTypeDataDetail/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
          } else {
            console.log(action)
            state.managePayTypeDetail.isEdit = true
            state.managePayTypeDetail.userData.prefix = action.payload.data.customer.prefix ? action.payload.data.customer.prefix : ''
            state.managePayTypeDetail.userData.name = action.payload.data.customer.name ? action.payload.data.customer.name : ''
            state.managePayTypeDetail.userData.idcard = action.payload.data.customer.idcard ? action.payload.data.customer.idcard : ''
            state.managePayTypeDetail.userData.birthday = action.payload.data.customer.birthday ? action.payload.data.customer.birthday : null
            state.managePayTypeDetail.userData.address = action.payload.data.customer.address ? action.payload.data.customer.address : ''
            state.managePayTypeDetail.userData.moo = action.payload.data.customer.moo ? action.payload.data.customer.moo : ''
            state.managePayTypeDetail.userData.soi = action.payload.data.customer.soi ? action.payload.data.customer.soi : ''
            state.managePayTypeDetail.userData.street = action.payload.data.customer.street ? action.payload.data.customer.street : ''
            state.managePayTypeDetail.userData.province = action.payload.data.customer.province ? action.payload.data.customer.province : ''
            state.managePayTypeDetail.userData.district = action.payload.data.customer.district ? action.payload.data.customer.district : ''
            state.managePayTypeDetail.userData.subdistrict = action.payload.data.customer.subdistrict ? action.payload.data.customer.subdistrict : ''
            state.managePayTypeDetail.userData.phone_1 = action.payload.data.customer.phone_1 ? action.payload.data.customer.phone_1 : ''
            state.managePayTypeDetail.userData.phone_2 = action.payload.data.customer.phone_2 ? action.payload.data.customer.phone_2 : ''
            state.managePayTypeDetail.userData.status = action.payload.data.status ? action.payload.data.status : null
            state.managePayTypeDetail.userData.application_code = action.payload.data.application_code ? action.payload.data.application_code : null
            state.managePayTypeDetail.userData.paid = action.payload.data.paid === 0 ? '0' : action.payload.data.paid
            state.managePayTypeDetail.userData.course_id = action.payload.data.paid ? action.payload.data.course_id.toString() : ''
            state.managePayTypeDetail.userData.discount = action.payload.data.discount === 0 ? '0' : action.payload.data.discount.toString()
            state.managePayTypeDetail.userData.net = action.payload.data.net === 0 ? '0' : action.payload.data.net.toString()
            state.managePayTypeDetail.userData.balance = action.payload.data.balance === 0 ? '0' : action.payload.data.balance.toString()
            state.managePayTypeDetail.userData.total = action.payload.data.total === 0 ? '0' : action.payload.data.total.toString()
            state.managePayTypeDetail.userData.payments = action.payload.data.payments
            state.managePayTypeDetail.userData.application_id = action.payload.data.application_id
            state.managePayTypeDetail.userData.is_foreigner = action.payload.data.customer.is_foreigner
            state.managePayTypeDetail.userData.course = [
              {
                course_id: action.payload.data.course_id ? action.payload.data.course_id.toString() : '',
                course_name: null,
                promotion_code: null,
                exam_date: null,
                cost: action.payload.data.balance ? action.payload.data.balance.toString() : '',
                discount: null,
                paid: null,
                pay_type: null
              }
            ]
          }
        }
      })
      .addCase(managePayTypeGetCourse.fulfilled, (state, action) => {
        if (action.type === 'managePayType/managePayTypeGetCourse/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
          } else {
            state.managePayTypeDetail.dropdown.course = action.payload.course
            state.managePayTypeDetail.dropdown.other_fee = action.payload.other_fee
          }
        }
      })
      .addCase(managePayTypeReaderCard.fulfilled, (state, action) => {
        if (action.type === 'managePayType/managePayTypeReaderCard/fulfilled') {
          if (action.payload.result === 'ok') {
            state.managePayTypeDetail.userData.prefix = action.payload.title_th
            state.managePayTypeDetail.userData.name = `${action.payload.fname_th} ${action.payload.sname_th}`
            state.managePayTypeDetail.userData.idcard = action.payload.nat_id
            state.managePayTypeDetail.userData.birthday = action.payload.birthdate
            state.managePayTypeDetail.userData.address = action.payload.address_no
            state.managePayTypeDetail.userData.street = action.payload.address_road
            state.managePayTypeDetail.userData.province = action.payload.address_provinice
            state.managePayTypeDetail.userData.district = action.payload.address_amphor
            state.managePayTypeDetail.userData.subdistrict = action.payload.address_tumbol
            state.managePayTypeDetail.userData.age = null

          } else {
            //handleError
          }
        }
      })
      .addCase(managePayTypePDFCreate.fulfilled, (state, action) => {
        console.log(action)
        if (action.type === 'managePayType/application/pdf/create/fulfilled') {
          if (action.payload.status === 'success') {
            window.open(action.payload.data.pdf, '_blank')
          } else {
            //handleError
          }
        }
      })
      .addCase(getAllData.fulfilled, (state, action) => {
        state.allData = action.payload
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.selectedUser = action.payload
      })

  }
})

export const { searchCriteria, managePayTypeNew, managePayTypeAddHandle, managePayTypeDropdownHandle, managePayTypeDeleteHandle, managePayTypeOnChangeHandle, managePayTypeLoading, managePayTypeAlert, managePayTypeRefundDelete } = managePayTypeSlice.actions

export default managePayTypeSlice.reducer
